import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EMPTY, Observable, Subject, of, throwError } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { ExdrLanguageService } from "../../languages/services/exdr-language.service";
import { Addon } from "../models/addon.model";
import {
  AUTH_TYPE_HEADER,
  AuthService,
  AuthType,
} from "../services/auth.service";
import { EspAuthService } from "../services/esp-auth.service";
import { TechnadoptAuthService } from "../services/technadopt-auth.service";
import { SharedService } from "../shared.service";
import { AlertService } from "../alert/alert.service";
import { TranslationHelperService } from "src/app/requests/esp/common/services/translation-helper.service";

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private espAuthService: EspAuthService,
    private router: Router,
    private sharedService: SharedService,
    private exdrLanguageService: ExdrLanguageService,
    private taAuth: TechnadoptAuthService,
    private alertService: AlertService,
    private translationHelperService: TranslationHelperService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
    const authType = this.authService.getAuthType(request);
    let changedReq: HttpRequest<unknown> = request;
    if (
      authType.toLowerCase() == AuthType.Technadopt.toLowerCase() &&
      this.sharedService.isDefaultTopic
    ) {
      changedReq = this.appendBaseUrl(
        changedReq,
        environment.technadoptApiHost + "/webapi"
      );
      return this.nextHandler(next, changedReq, authType);
    }
    return this.authService.getAuthAddonByType(authType).pipe(
      switchMap((addon) => {
        if (addon) {
          if (request.url.indexOf("://") === -1 && addon.BaseUrl) {
            if (addon.BaseUrl.includes("http://")) {
              // added https in place of http cause some apis of SS giving CORS issue
              addon.BaseUrl = addon.BaseUrl.replace("http://", "https://");
            }
            changedReq = this.appendBaseUrl(changedReq, addon.BaseUrl);
          }

          let accessToken: string = addon.AccessToken;

          if (addon.Type?.toLowerCase() === AuthType.Technadopt) {
            accessToken = addon.technadoptAuthData
              ? addon.technadoptAuthData.accessToken
              : accessToken;
          } else if (addon.Type == AuthType.SimpleStrata) {
            accessToken = localStorage.getItem("SignInByIdenediToken");
          }

          if (accessToken) {
            changedReq = this.appendAccessToken(changedReq, accessToken);
          }

          if (addon.Type == AuthType.ESP) {
            if (!changedReq.headers.has('locale')) {
              changedReq = this.appendLocale(
                changedReq,
                this.exdrLanguageService.currentLanguage.locale
              );
            }
          }

          if (addon.Type == AuthType.OppPro) {
            changedReq = this.appendSellexeHeaders(changedReq);
            console.log('@addOn', addon)
            console.log('@changedReq', changedReq)
          }
        }

        if (changedReq.headers.has(AUTH_TYPE_HEADER)) {
          changedReq = changedReq.clone({
            headers: changedReq.headers.delete(AUTH_TYPE_HEADER),
          });
        }
        return this.nextHandler(next, changedReq, authType, addon);
      })
    );
  }

  private appendLocale(
    request: HttpRequest<unknown>,
    locale: string
  ): HttpRequest<unknown> {
    let headers = request.headers;
    headers = headers.delete("locale");
    headers = headers.append("locale", locale);
    return request.clone({
      headers: headers,
    });
  }

  private appendSellexeHeaders(
    request: HttpRequest<unknown>
  ): HttpRequest<unknown> {
    let headers = request.headers;
    //adsf
    return request.clone({
      headers: headers,
    });
  }

  private appendAccessToken(
    request: HttpRequest<unknown>,
    token: string
  ): HttpRequest<unknown> {
    let headers = request.headers;
    headers = headers.delete("Authorization");
    headers = headers.delete("authorization");
    headers = headers.delete(AUTH_TYPE_HEADER);
    headers = headers.append("Authorization", "Bearer " + token);
    return request.clone({
      headers: headers,
    });
  }

  private appendBaseUrl(
    request: HttpRequest<unknown>,
    baseUrl: string
  ): HttpRequest<unknown> {
    var finalUrl: string;
    const allowedRequests = [
      'activities-svc',
      'notes-svc',
      'ai-svc',
      'performance-svc'
    ]
    if(baseUrl.includes("web.simplestrata.com")) {
      baseUrl = baseUrl.replace("web.simplestrata.com", "ss-production-gateway.azurewebsites.net");
    }
    // // Check if the request URL starts with 'activities-svc' or notes-svc or performance-svc
    // if (request.url.startsWith('ai-svc')){
    //   const modifiedBaseUrl = "https://ss-production-gateway.azurewebsites.net/";
    //   finalUrl = modifiedBaseUrl + request.url // Construct the final URL
    // }
    // if (request.url.startsWith('activities-svc') || request.url.startsWith('notes-svc') || request.url.startsWith('ai-svc') || request.url.startsWith('performance-svc')) {
    if (allowedRequests.some(service => request.url.startsWith(service))) {
      finalUrl = (baseUrl.replace(/\/$/, "") + "/" + request.url.replace(/^\//, "")).replace(/\/WebApi(?=\/|$)/i, "") 
    } else {
      finalUrl = baseUrl.replace(/\/$/, "") + "/" + request.url.replace(/^\//, "");
    }

    return request.clone({ url: finalUrl });
  }
  //
  refreshTokenInProgress = false;
  tokenRefreshedSource: Subject<void> = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

  private refreshToken() {
    if (this.refreshTokenInProgress) {
      return new Observable((observer) => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next(null);
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;

      return this.authService.tryRefreshIdenediToken().pipe(
        tap(() => {
          this.refreshTokenInProgress = false;
          this.tokenRefreshedSource.next();
        })
      );
    }
  }

  private nextHandler(
    next: HttpHandler,
    request: HttpRequest<unknown>,
    authType: AuthType,
    addon?: Addon
  ): Observable<HttpEvent<unknown>> {
    const request$ = (req: HttpRequest<unknown>) =>
      next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          //Show error alert only for ESP API calls
          if (authType.toLowerCase() == AuthType.ESP.toLowerCase() && error instanceof HttpErrorResponse && !req.headers.has('ignoreErrorMessage')) {
            if (error.status != 400 && error.status != 404 && error.status != 409) {
              this.alertService.error(this.translationHelperService.getTranslationByKey('Common.ERROR'));
            }
          }

          if (error.status === 401) {
            if (authType == AuthType.Idenedi) {
              if (this.authService.isLoggedIn()) {
                return this.refreshToken().pipe(
                  switchMap(() => {
                    request = this.appendAccessToken(
                      request,
                      this.authService.idenediToken
                    );
                    return next.handle(request);
                  }),
                  catchError((err) => {
                    this.authService.logout();
                    return throwError(() => error);
                  })
                );
              }
            } else if (authType.toLowerCase() == AuthType.ESP.toLowerCase()) {
              if (this.authService.isLoggedIn()) {
                return this.espAuthService.getEspAuth().pipe(
                  switchMap((espAddon) => {
                    espAddon.AccessToken = "";
                    return this.espAuthService.getEspToken().pipe(
                      switchMap((espAddonWithToken) => {
                        request = this.appendAccessToken(
                          request,
                          espAddonWithToken.AccessToken
                        );
                        return next.handle(request);
                      }),
                      catchError((err) => {
                        console.error("Unable to execute esp https requests.");
                        // this.router.navigateByUrl("/pages/404");
                        // this.router.navigateByUrl("/home");
                        //this.authService.logout();
                        return throwError(() => error);
                      })
                    );
                  })
                );
              }
            } else if (authType == AuthType.Technadopt && !this.sharedService.isDefaultTopic) {
              return this.taAuth.refreshToken(addon).pipe(
                switchMap((taAddon) => {
                  request = this.appendAccessToken(
                    request,
                    taAddon.technadoptAuthData.accessToken
                  );
                  return next.handle(request);
                })
              );
            }
          } else if (error.status == 409 && authType.toLowerCase() == AuthType.ESP.toLowerCase() && error?.error?.result) {
            const errorMsg = this.parseEspServerMessage(error);
            if (errorMsg) {
              this.alertService.error(errorMsg);
            }
          }
          // else if (error.status == 400 || error.status == 500) {
          //   this.router.navigateByUrl("/pages/404");
          // }
          return throwError(() => error);
        })
      );

    return this.tryRefreshTokenIfNeeded(authType).pipe(
      map((tokenRefreshed) => {
        if (tokenRefreshed && authType == AuthType.Idenedi) {
          return this.appendAccessToken(request, this.authService.idenediToken);
        }
        return request;
      }),
      switchMap((req) => request$(req))
    );
  }

  tryRefreshTokenIfNeeded(authType: AuthType) {
    if (
      authType !== AuthType.None &&
      this.authService.isLoggedIn() &&
      this.authService.isIdenediTokenExpired()
    ) {
      return this.refreshToken().pipe(map((_) => true));
    } else {
      return of(false);
    }
  }

  private parseEspServerMessage(error: any): string | null {
    const raw = error?.error?.result ?? error?.error;
    if (!raw) return null;
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return parsed?.Message ?? parsed?.message ?? null;
    } catch {
      // raw is not JSON; if it's plain text return it, otherwise null
      return typeof raw === 'string' ? raw : null;
    }
  }
  //
}
